<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="gridName" label="网格名称">
              {{ formData.gridName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="areaName" label="区域名称">
              {{ formData.areaName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deptName" label="责任部门名称">
              {{ formData.deptName || '--' }}
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'GridMangeDetail',
  data() {
    return {
      formData: {
        areaId: '', // 区域id
        areaName: '',
        gridName: '', // 网格名称
        deptId: '', // 责任部门id
        deptName: '' // 责任部门名称
      }
    }
  },
  created() {
    if (this.gridId) {
      this.loadData()
    }
  },
  computed: {
    gridId() {
      return this.$route.query.gridId
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryGridByGridId, { gridId: this.gridId }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
